module.exports = __webpack_public_path__ + "2fda561d.png";